// extracted by mini-css-extract-plugin
module.exports = {"clip":"ClipAnimation_clip__CVIHY","reverse":"ClipAnimation_reverse__mGlHI","reveal":"ClipAnimation_reveal__EVHVG","long":"ClipAnimation_long__J3gj1"};